import { Alert, Modal, Skeleton } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { getEinvoiceReminderPreviewHtml } from '@/services/einvoiceReminders.service';

/**
 * The reminder mail of one company exactly as it would go out on the next
 * send day (or on `date`). Rendered by the server; shown in a sandboxed frame.
 */
export default function EinvoiceMailPreview({ companyId, companyName, date, onClose }) {
  const { t } = useTranslation('einvoiceReminders');
  const { data, isLoading, error } = useQuery({
    queryKey: ['einvoice-reminder-mail', companyId, date || ''],
    queryFn: () => getEinvoiceReminderPreviewHtml(companyId, date),
    enabled: !!companyId,
  });
  return (
    <Modal
      open={!!companyId}
      onCancel={onClose}
      footer={null}
      width={820}
      title={`${t('mail.title')}: ${companyName || ''}`}
      destroyOnClose
    >
      {isLoading && <Skeleton active />}
      {error && <Alert type="error" showIcon className="!static" message={error?.response?.data?.message || error.message} />}
      {data && (
        <div className="grid gap-2">
          <div className="text-sm">
            <span className="opacity-60">{t('mail.subject')}:</span> <b>{data.subject}</b>
          </div>
          <iframe title="mail" sandbox="" srcDoc={data.html} style={{ width: '100%', height: '65vh', border: '1px solid rgba(0,0,0,.1)', borderRadius: 8 }} />
        </div>
      )}
    </Modal>
  );
}
